<template>
  <RevCard class="p-16">
    <h3 class="heading-3 mb-32">
      {{ i18n(translations.title) }}
    </h3>

    <RevStatusTracker class="m-24 md:mx-72" :current-step="activeStep" :steps>
      <template v-for="step in steps" :key="step.key" #[`${step.key}-date`]>
        {{ step.date }}
      </template>
    </RevStatusTracker>
  </RevCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevStatusTracker } from '@ds/components/StatusTracker'

import type { OrderDetails } from '../../OrderDetails.types'

import { DATE_FORMAT } from './OrderStatus.constants'
import translations from './OrderStatus.translations'

const props = defineProps<{ orderDetails: OrderDetails }>()

const i18n = useI18n()

function getDate(datetime?: string) {
  return datetime ? i18n.date(new Date(datetime), DATE_FORMAT) : undefined
}

const steps = computed(() => [
  {
    key: 'creation',
    label: i18n(translations.creationStatus),
    date: getDate(props.orderDetails.creationDate),
  },
  {
    key: 'paid',
    label: i18n(translations.paidStatus),
    date: getDate(props.orderDetails.paymentDate),
  },
  {
    key: 'confirmed',
    label: i18n(translations.confirmedStatus),
    date: getDate(props.orderDetails.confirmationDate),
  },
  {
    key: 'shipped',
    label: i18n(translations.shippedStatus),
    date: getDate(props.orderDetails.shippingDate),
  },
  {
    key: 'pickup',
    label: i18n(translations.pickupDate),
    date: getDate(props.orderDetails.pickupDate),
  },
  {
    key: 'delivered',
    label: i18n(translations.deliveredStatus),
    date: getDate(props.orderDetails.deliveryDate),
  },
])

const activeStep = computed(
  () =>
    [...steps.value].reverse().find((step) => Boolean(step.date))?.key ||
    steps.value[0].key,
)
</script>
